import { CategoryManager } from "@/components/management/CategoryManager";
import { MobileLayout } from "@/components/layout/MobileLayout";
import { useIsMobile } from "@/hooks/use-mobile";

export default function Categories() {
  const isMobile = useIsMobile();

  const handleTabChange = (tab: string) => {
    // Handle tab navigation if needed
  };

  const handleTransactionSuccess = () => {
    // Handle transaction success if needed
  };

  if (isMobile) {
    return (
      <MobileLayout
        currentTab="categories"
        onTabChange={handleTabChange}
        onTransactionSuccess={handleTransactionSuccess}
      >
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-2xl font-bold mb-4 mt-4">Categorias</h1>
          <CategoryManager onCategoryUpdate={() => {}} />
        </div>
      </MobileLayout>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="p-3 sm:p-4 md:p-6">
        <div className="max-w-7xl mx-auto">
          <CategoryManager onCategoryUpdate={() => {}} />
        </div>
      </div>
    </div>
  );
}